import { inject, Injectable, signal, WritableSignal } from "@angular/core";
import { Filter, Query } from "../assets/asset-filter.service";
import { FilterPanelItem } from "app/shared/components/filter-panel/filter-panel.model";
import { Router } from "@angular/router";

/**
 * Service that holds options to be used for the metrics service.
 * Allows for holding references of specific data that may be required cross compoents.
 */
@Injectable({ providedIn: 'root' })
export class MetricsOptionsService {

    //#region Signals

    private _source: WritableSignal<string | null> = signal(null);
    private flowInstanceId: number | null;
    private router = inject(Router);

    //#endregion

    //#region Variables

    public readonly source = this._source.asReadonly();

    //#endregion

    //#region Public Methods

    public setSource(source: string | null) { this._source.set(source); }

    public getFlowInstanceId(reset: boolean = false): number {
        if (reset) {
            this.flowInstanceId = null;
        }
        if (!this.flowInstanceId) {
            this.flowInstanceId =  Math.floor(Date.now() / 1000);
        }
        return this.flowInstanceId;
    }

    public getScreenFromUrl(): string | null {
        const url = this.router.url;

        if (url.includes('status')) return 'live_map';
        if (url.includes('history')) return 'trip_history';

        return null;
    }

    public isPage(page: string): boolean{
        return this.router.url.includes(page);
    }

    /**
     * Formats the filters passed to this method to return a formatted string array.
     * @param prefix the prefix for the value
     * @param filter the filter values to format.
     * @returns string array of filter values.
     */
    public getFilterValues(prefix: string, filter: Query | Filter | FilterPanelItem[]): string[] {
        if (!filter || typeof filter !== 'object') return [];

        const filters = (filter as FilterPanelItem[]);
        if (Array.isArray(filters)) return filters.map(q => `${prefix}:${q.id}`);

        const queries = (filter as Filter).queries;
        if (Array.isArray(queries)) return queries.map(q => `${prefix}:${q.display}`);

        const display = (filter as Query).display;
        return display ? [`${prefix}:${display}`] : [];
    }

    //#endregion
}